import React from 'react';
import { Box, Typography, Button, Container, Grid } from '@mui/material';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

const stats = [
  { value: '3x', label: 'More Admissions' },
  { value: '60%', label: 'Faster Follow-ups' },
  { value: '80%', label: 'Drop in No-shows' },
  { value: '₹0', label: 'Setup Fee' },
];

const DemoStrip = () => (
  <Box sx={{ background: 'linear-gradient(90deg, #233098 0%, #684df4 100%)', py: { xs: 5, md: 6 } }}>
    <Container maxWidth="lg">
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={5}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <RocketLaunchIcon sx={{ color: '#c4b5fd', fontSize: 36 }} />
            <Typography variant="h4" sx={{ color: '#fff', fontWeight: 800, fontFamily: "'Montserrat', sans-serif", fontSize: { xs: '1.5rem', md: '2rem' } }}>
              Simplify. Automate. Grow.
            </Typography>
          </Box>
          <Typography sx={{ color: 'rgba(255,255,255,0.78)', fontSize: 16, fontFamily: "'Montserrat', sans-serif", lineHeight: 1.7, mb: 3 }}>
            Start your free trial today. No credit card. No setup fee. Just results from day one.
          </Typography>
          <Button variant="contained" size="large"
            sx={{ bgcolor: '#fff', color: '#233098', fontWeight: 800, px: 4, py: 1.5, borderRadius: '12px', fontFamily: "'Montserrat', sans-serif", fontSize: 15, '&:hover': { bgcolor: '#e1eaff' } }}>
            Start Free Trial
          </Button>
        </Grid>
        <Grid item xs={12} md={7}>
          <Grid container spacing={3}>
            {stats.map((s, i) => (
              <Grid item xs={6} md={3} key={i} sx={{ textAlign: 'center' }}>
                <Typography sx={{ color: '#c4b5fd', fontWeight: 900, fontSize: '2.4rem', fontFamily: "'Montserrat', sans-serif", lineHeight: 1 }}>{s.value}</Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: 13, fontFamily: "'Montserrat', sans-serif", mt: 0.5 }}>{s.label}</Typography>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  </Box>
);

export default DemoStrip;
